import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import gsap from "gsap";
import jquery from "../../node_modules/jquery/src/jquery.js";
import barba from "@barba/core";

UIkit.use(Icons);

/**
 * Rende disponibili le librerie nello scope globale.
 * Alternativamente, spostare gli import in app.js
 */
window.UIkit = UIkit;
window.gsap = gsap;
window.$ = jquery;
window.barba = barba;